import React from 'react';
import ReactDOM from 'react-dom';

export default function StickyHeaderPortal({ children }) {
  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      background: '#090e21',
      color: '#fff',
      zIndex: 9999,
      padding: '0',
      boxShadow: '0 2px 16px 0 rgba(20,20,60,0.18)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      margin: 0,
      boxSizing: 'border-box',
      transition: 'height 0.3s ease-in-out',
    }}>
      {children}
    </div>,
    document.body
  );
} 